import { useTranslation } from 'react-i18next';

// Contingut comú de la pàgina 404 de la web pública. Cada plantilla l'embolcalla amb el seu menú i peu.
const PaginaNoEncontrada = ({ urlinicio, websgrupo }) => {

    const { t } = useTranslation();

    const color = (websgrupo && websgrupo.color_corporativo_web) || 'var(--corporatiu, #333333)';

    return (
        <section style={{ padding: '120px 16px 140px', textAlign: 'center' }}>
            <div style={{ maxWidth: '640px', margin: '0 auto' }}>
                <p style={{ fontSize: '96px', fontWeight: 700, lineHeight: 1, margin: '0 0 24px', color: color }}>
                    404
                </p>
                <h1 style={{ fontSize: '32px', margin: '0 0 16px' }}>
                    {t("Página no encontrada")}
                </h1>
                <p style={{ fontSize: '18px', margin: '0 0 40px', opacity: 0.8 }}>
                    {t("Lo sentimos, la página que buscas no existe o ha cambiado de dirección.")}
                </p>
                <a
                    href={urlinicio}
                    style={{
                        display: 'inline-block',
                        padding: '14px 32px',
                        borderRadius: '4px',
                        backgroundColor: color,
                        color: '#ffffff',
                        textDecoration: 'none',
                    }}
                >
                    {t("Volver al inicio")}
                </a>
            </div>
        </section>
    );
}

export default PaginaNoEncontrada;
